const translations = {
  PageTitle: "Dataset Viewer",
  FetchError: "Failed to load datasets",
  ObjectDatasetsTab: "Object Datasets",
  DefectDatasetsTab: "Defect Datasets",
  Name: "Name",
  TypeList: "Type List",
  Date: "Date",
  Whitelist: "Approved Projects",
  Blacklist: "Non-Included Projects",
  SyntheticProjects: "Synthetic Projects",
  Sensitive: "Sensitive",
  SearchPlaceholder: "Search datasets…",
  FilterByType: "Filter by type…",
  HideInaccessible: "Hide datasets with no accessible projects",
  InaccessibleProject: "Project not found — it may be on another domain",
  UnknownProject: (id: number) => `Unknown project #${id}`,
  Settings: "Settings",
  ProjectNameDisplay: "Project Name Display",
  DisplayID: "ID",
  DisplayIDAndName: "ID & Name",
  LoadingImages: "Loading…",
  ImageCount: (count: number) => `${count.toLocaleString()} images`,
  ProjectCount: (count: number) => `${count.toLocaleString()} projects`,
  Filter: "Filter",
  SplitFilterLabel: "Train / Test",
  SplitAll: "Both",
  SplitTrain: "Train",
  SplitTest: "Test",
  ActiveImageHiddenByFilter: "The current image is hidden by this filter",
  ImageNotFound: "Image not found in dataset",
  FailedToLoadImages: "Failed to load dataset images",
  FailedToLoadDataset: "Failed to load dataset",
  FailedToLoadAnnotations: "Failed to load annotations",
  OpenInAnnotationToolOn: (domainName: string) =>
    `Open in Annotation Tool (${domainName})`,
  TrainImage: "Train image",
  TestImage: "Test image",
  AnnotationToolUnavailable:
    "Project not found in this region — annotation tool unavailable",
  ImageErrorNotFound: "Image does not exist in CDN, perhaps it was deleted?",
  ImageErrorUnauthorized: "You do not have access to this project",
  ImageErrorGeneric: (errorCode: number | string) =>
    `Failed to load image (${errorCode})`,
  Original: "Original",
  Augmented: "Augmented",
  NoImageCropsFound: "No crops found for this image in dataset.",
};

export default translations;
